import angular from 'angular';
import { LoadParams } from '../../../shared/models/loadparams.model';
import { IAfastado, IAfastadoBody, IRelatorioAfastadoBody } from './models/afastados.model';

export class AfastadosService {
    static $inject = ['$http', '$rootScope', '$q', 'nsjRouting'];

    public loading_deferred: angular.IDeferred<unknown>;
    public loadParams: LoadParams = new LoadParams();

    constructor(
        public $http: angular.IHttpService,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService,
        public nsjRouting: any,
    ) {}

    getAfastados(entity: IAfastadoBody) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IAfastado[]>, reject) => {
            this.$http.post<IAfastado[]>(
                this.nsjRouting.generate('meurh_solicitacoesafastamentos_afastados', {}, true), entity, {
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesafastamentos_afastados_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesafastamentos_afastados_error', response);
                reject(response);
            });
        });
    }

    getRelatorioAfastados(entity: IRelatorioAfastadoBody) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<angular.IHttpResponse<File>>, reject) => {
            this.$http.post<File>(
                this.nsjRouting.generate('meurh_solicitacoesafastamentos_afastados', {}, true), entity, {
                responseType: 'blob',
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesafastamentos_afastados_relatorio_loaded', response);
                resolve(response);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesafastamentos_afastados_relatorio_error', response);
                reject(response);
            });
        });
    }
}
